export function trackEvent (eventName, eventLabel = null, params = null, position = null, eventText = null) {
  if (typeof window.gtag === 'function') {
    if (eventLabel && position) {
      window.gtag('event', eventName, { event_label: eventLabel, position })
    } else if (eventLabel && eventText) {
      window.gtag('event', eventName, { event_label: eventLabel, text: eventText })
    } else if (eventLabel) {
      window.gtag('event', eventName, { product: eventLabel })
    } else if (params) {
      window.gtag('event', eventName, params)
    } else {
      window.gtag('event', eventName)
    }
  }
}

export const trackGtag = (eventName, params = {}) => {
  if (typeof window.gtag !== 'function') {
    return
  }

  const baseParams = { product: 'renewal', category: 'carIns' }

  const eventParams = {
    ...baseParams,
    ...params
  }

  if (eventParams.ecommerce) {
    eventParams.ecommerce = JSON.stringify(eventParams.ecommerce)
  }

  window.gtag('event', eventName, eventParams)
}

export function calculateAge (dateOfBirth) {
  const today = new Date()
  const birthDate = new Date(dateOfBirth)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}
